import LocalizedStrings from 'localized-strings';

import { TeamMemberRole } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    currentRole: 'Current role',
    free: 'Free',
    proBusinessOnly:
      'Admin and employee access are only available on Pro and Business plans',
    roles: {
      [TeamMemberRole.AccountHolder]: {
        description: 'N/A',
        label: 'N/A',
      },
      [TeamMemberRole.Admin]: {
        description: 'Full access.',
        label: 'Admin',
      },
      [TeamMemberRole.Accountant]: {
        description: 'Access restricted to transactions and exports.',
        label: 'Accountant',
      },
      [TeamMemberRole.Employee]: {
        description: 'Access limited to their expenses.',
        label: 'Employee',
      },
    },
    roleSelectionHelp: {
      description: 'Find details of the different roles in our',
      descriptionLink: 'help center',
      title: '💡 Which role to choose?',
    },
    upgradePlan: 'Upgrade my plan',
  },
  fr: {
    currentRole: 'Rôle actuel',
    free: 'Gratuit',
    proBusinessOnly:
      'Les accès admin et employé sont accessibles seulement sur les plans Pro et Business',
    roles: {
      [TeamMemberRole.AccountHolder]: {
        description: 'N/A',
        label: 'N/A',
      },
      [TeamMemberRole.Admin]: {
        description: 'Accès complet au compte.',
        label: 'Admin',
      },
      [TeamMemberRole.Accountant]: {
        description: 'Accès limité aux transactions et exports.',
        label: 'Comptable',
      },
      [TeamMemberRole.Employee]: {
        description: 'Accès limité à ses dépenses.',
        label: 'Employé·e',
      },
    },
    roleSelectionHelp: {
      description: 'Retrouver le détail des différents rôles dans notre',
      descriptionLink: "centre d'aide",
      title: '💡 Quel rôle choisir ?',
    },
    titleAccountOnly: 'Inviter votre comptable à rejoindre votre compte Shine',
    upgradePlan: 'Mettre à niveau mon plan',
  },
} as const);

export default locales;
